import 'css-chunksrc/client/scenes/workloads/graph/elementsOverlay/element/task/styles.scss';export default {
  "task": "_task_14iml_1",
  "hovered": "_hovered_14iml_11",
  "completed": "_completed_14iml_14",
  "late": "_late_14iml_14",
  "unScheduled": "_unScheduled_14iml_18",
  "withStartDate": "_withStartDate_14iml_25",
  "withEndDate": "_withEndDate_14iml_32",
  "blocked": "_blocked_14iml_46",
  "derived": "_derived_14iml_74",
  "completedAtEndDate": "_completedAtEndDate_14iml_93"
};